import { STORYBLOK_TYPES } from '~/lib/storyblok-types'
import BlogListPage from '~/pages/journal'

import { getBlogListStaticPropsFunction } from '~/data/blog-list-page-data'
import { getPaginatedStaticPathsFunction } from '~/data/page-data'

export default BlogListPage

export const getStaticProps = getBlogListStaticPropsFunction()
export const getStaticPaths = getPaginatedStaticPathsFunction({
  withPage: true,
  type: STORYBLOK_TYPES.BLOG_CATEGORY,
})
